import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import { contactInfo } from '../data/mock';
import { subscribeToNewsletter } from '../lib/newsletter';

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const data = await subscribeToNewsletter(newsletterEmail);
      if (data.success) {
        toast.success(data.message || 'Thank you for subscribing!');
        setNewsletterEmail('');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      toast.error(error.message || 'An error occurred. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="bg-emerald-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="text-center lg:text-left">
              <h3 className="text-xl font-bold text-white mb-1">Stay Updated</h3>
              <p className="text-emerald-100 text-sm">Subscribe to our newsletter for updates on programs and impact stories.</p>
            </div>
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <input type="email" required placeholder="Enter your email" value={newsletterEmail} onChange={(event) => setNewsletterEmail(event.target.value)} className="flex-1 lg:w-72 h-11 px-4 rounded-lg border-0 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-emerald-300" data-testid="footer-newsletter-email" />
              <button type="submit" disabled={isSubmitting} className="h-11 px-6 bg-white text-emerald-700 font-semibold rounded-lg hover:bg-emerald-50 transition-colors flex items-center justify-center gap-2" data-testid="footer-newsletter-submit">
                {isSubmitting ? 'Subscribing...' : <>Subscribe <Send className="w-4 h-4" /></>}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4"><img src="/delinam-logo.png" alt="Delinam Foundation Logo" className="h-10 w-auto object-contain" /><div><span className="text-lg font-bold text-emerald-800 leading-tight">Delinam</span><span className="block text-xs text-emerald-600 leading-tight">Foundation</span></div></div>
            <p className="text-sm text-gray-600 leading-relaxed">Empowering communities through sustainable development and local leadership.</p>
          </div>
          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-2">{[['/','Home'],['/about','About Us'],['/programs','Our Work'],['/get-involved','Get Involved'],['/contact','Contact']].map(([to,label]) => <li key={to}><Link to={to} className="text-sm text-gray-600 hover:text-emerald-700 transition-colors">{label}</Link></li>)}</ul>
          </div>
          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Contact</h3>
            <a href={`mailto:${contactInfo.email}`} className="flex items-start space-x-3 text-sm text-gray-600 hover:text-emerald-700 transition-colors"><Mail className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" /><span>{contactInfo.email}</span></a>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-600">© {new Date().getFullYear()} Delinam Foundation. All rights reserved.</p>
          <div className="flex space-x-6"><Link to="/privacy" className="text-sm text-gray-600 hover:text-emerald-700">Privacy Policy</Link><Link to="/terms" className="text-sm text-gray-600 hover:text-emerald-700">Terms of Service</Link><Link to="/donations-policy" className="text-sm text-gray-600 hover:text-emerald-700">Donations Policy</Link><Link to="/volunteer-code" className="text-sm text-gray-600 hover:text-emerald-700">Volunteer Code</Link></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
